/**
 * Format a byte count as a compact, human-readable string — e.g. `0 B`, `812 B`, `20 KB`,
 * `1,5 MB`. Uses binary (1024) steps; the numeric part is rendered with the Belgian locale
 * (`fr-BE`) to stay consistent with the rest of the app (so `1.5` shows as `1,5`).
 *
 * - Returns `'—'` (em dash) for `null` or a non-finite input.
 */
const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

const BYTES_FORMATTER = new Intl.NumberFormat('fr-BE', { maximumFractionDigits: 1 });

export function formatBytes(bytes: number | null): string {
  if (bytes === null || !Number.isFinite(bytes)) {
    return '—';
  }
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${BYTES_FORMATTER.format(value)} ${UNITS[unit]}`;
}
